<template>
  <el-container class="body_container">
    <el-header style="height: 100px;padding:0px">
      <el-row class="body_title">通告</el-row>
      <el-row type="flex">
        <el-col>
          <el-form :model="searchVo" :inline="true" size="small">
            <el-form-item>
              <!--<el-date-picker-->
                <!--style="width: 300px"-->
                <!--v-model="dateData"-->
                <!--type="daterange"-->
                <!--unlink-panels-->
                <!--:picker-options="pickerOption"-->
                <!--range-separator="至"-->
                <!--format="yyyy-MM-dd"-->
                <!--value-format="yyyy-MM-dd"-->
                <!--start-placeholder="开始日期"-->
                <!--end-placeholder="结束日期">-->
              <!--</el-date-picker>-->
              <el-date-picker
                v-model="dateData"
                type="datetime"
                placeholder="选择日期">
              </el-date-picker>
              <el-input v-model="searchVo.keyword" auto-complete="off" placeholder="查询标题或内容" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item class="dialog-footer">
              <el-button type="primary" @click="search">查询</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col style="text-align: right" :span="4">
          <el-button  @click="add" type="primary">新建通告</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="search_result">
      <el-table :data="noticeData.list">
        <el-table-column prop="title" label="通知标题" min-width="180px"></el-table-column>
        <el-table-column prop="content" label="内容" min-width="240px"></el-table-column>
        <el-table-column prop="createdBy" label="发布人" width="180px"></el-table-column>
        <el-table-column prop="createdTime" label="发布时间" width="180px"></el-table-column>
        <el-table-column prop="handle" label="操作" width="80px">
          <template slot-scope="scope">
            <!--<i class="el-icon-edit" @click="editNotice(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>-->
            &nbsp;
            <i class="el-icon-delete" @click="delNotice(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            <!--</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-pagination class="page"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-size="noticeData.rows"
                   :current-page="noticeData.page"
                   layout="prev, pager, next, jumper"
                   :total="noticeData.total">
    </el-pagination>
    <el-dialog title="通知公告" :visible.sync="noticeDialog">
     <el-form :model="notice" size="small" >
       <el-form-item label="通知标题" label-width="70px">
         <el-input v-model="notice.title" type="text"></el-input>
       </el-form-item>
       <el-form-item label="内容" label-width="70px">
         <quill-editor class="editor"
                 v-model="content"  
                 ref="myQuillEditor"  
                 :options="editorOption"  
                 @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                 @change="onEditorChange($event)">
         </quill-editor>
       </el-form-item>
     </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('notice')">{{'取消'}}</el-button>
        <el-button type="primary" @click="save" :loading="isLoading">{{publishName}}</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import notice from '@/api/notice'
// import Editor from '@/components/notice/Editor'
import {quillEditor} from 'vue-quill-editor'
export default {
  name: 'Notification',
  data () {
    return {
      noticeDialog: false,
      noticeData: {
        page: 1,
        rows: 10,
        total: 0,
        list: []
      },
      searchVo: {
        keyword: '',
        start_time: '',
        end_time: ''
      },
      dateData: '',
      pickerOption: {
        onPick: dateRange => {
          if (!dateRange.maxDate) {
            return
          }
          this.dateData = [dateRange.minDate, dateRange.maxDate]
        }
      },
      notice: {},
      createdTime: '',
      updateStatus: false,
      publishName: '',
      content: null,
      editorOption: {
        placeholder: '请输入...',
        modules: {toolbar: [["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{header: 1}, {header: 2}],
            [{list: "ordered"}, {list: "bullet"}],
            [{size: ["small", !1, "large", "huge"]}],
            [{header: [1, 2, 3, 4, 5, 6, !1]}],
            [{color: []}, {background: []}]
          ]}
      },
      isLoading: false
    }
  },
  methods: {
    reload () {
      notice.list({title: this.searchVo.keyword,
                  page: this.noticeData.page,
                  rows: this.noticeData.rows,
                  createdTime: this.createdTime,
                  status: 0}).then(res => {
        // console.log(res.data.data)
        this.noticeData = res.data.data
        let arr = []
        let obj = {}
        this.noticeData.list.forEach(item => {
          obj = {
            id: item.id,
            title: item.title,
            content: this.removeHtml(item.content),
            createdBy: item.createdBy,
            createdTime: item.createdTime,
            updatedBy: item.updatedBy,
            updatedTime: item.updatedTime
          }
          arr.push(obj)
        })
        this.noticeData.list = arr
      })
    },
    //时间格式化函数，此处仅针对yyyy-MM-dd hh:mm:ss 的格式进行格式化
    dateFormat:function(time) {
      var date=new Date(time);
      var year=date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
      var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
      var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
      var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
      var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
      // 拼接
      return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
    },
    editNotice (row) {
      this.updateStatus = true
      this.notice = row
      this.noticeDialog = true
      this.publishName = '重新发布'
      this.content = row.content
      // this.notice = row
      console.log(this.notice)
    },
    // 搜索
    search () {
      if (this.dateData!=null) {
        // 调用方法
        let time = this.dateFormat(this.dateData)
        this.createdTime = time
      }else {
        this.createdTime = ''
      }
      this.reload()
    },
    delNotice (row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        notice.delNotice({id: row.id}).then(res => {
          if (res.data.code===0) {
            this.$message({
              type: 'success',
              message: res.data.message
            });
            this.reload()
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSizeChange (val) {
      this.noticeData.page = val
      this.reload()
    },
    handleCurrentChange (val) {
      this.noticeData.page = val
      this.reload()
    },
    add () {
      this.noticeDialog = true
      this.publishName = '发布通告'
    },
    save () {
      if (this.notice.title=== null || this.notice.title === '' || this.content === null || this.content === '') {
        this.$message({
          type: 'error',
          message: '请输入标题或内容'
        });
      } else {
        this.isLoading=true
        this.notice.type= 'N'
        this.notice.content= this.content
        notice.publishNotice(this.notice).then(res => {
          if (res.data.code===0) {
            this.$message({
              type: 'success',
              message: res.data.message
            });
            this.isLoading=false
            this.notice = {}
            this.content = null
            this.noticeDialog = false
            this.updateStatus = false
            this.reload()
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        })
      }
    },
    cancel () {
      this.isLoading=false
      this.notice = {}
      this.content = null
      this.noticeDialog = false
      this.updateStatus = false
    },
    removeHtml (content) {
      return content.replace(/<[^>]+>/g, "")
    },
    onEditorBlur() {
    },
    onEditorFocus() {//获得焦点事件
    },
    onEditorChange() {//内容改变事件
    }
  },
  created () {
    this.reload()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/notice/Notification.vue